import React from 'react';
import { Alert, Typography } from '@mui/material';

import { useMerchant } from '../contexts/MerchantContext';

/** Shown on configuration pages for parent merchants so users know saves may inherit below. */
export function ParentHierarchySettingsBanner() {
  const { hasDescendants } = useMerchant();

  if (!hasDescendants) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 3 }} data-testid="parent-hierarchy-settings-banner">
      <Typography variant="medium" component="span" color="inherit">
        <Typography component="span" fontWeight={600} color="inherit">
          Note:
        </Typography>{' '}
        Some settings on this page also apply to child merchants. When you save, those child
        merchants inherit these changes unless they&apos;ve set their own value.
      </Typography>
    </Alert>
  );
}
